$(document).ready(function () {
  $("[data-fancybox='gallery']").fancybox({
    helpers: { thumbs: { width: 60, height: 60 } },
    openEffect: "elastic",
    closeEffect: "elastic"
  });

  var thumbSwiper = new Swiper(".mobile-thumb-swiper", {
    slidesPerView: 4,
    spaceBetween: 8,
    watchSlidesProgress: true,
    freeMode: true
  });

  const mySwiper = new Swiper(".media_swiper_wrapper", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    autoplay: false,
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    pagination: { el: ".swiper-pagination", clickable: true },
    thumbs: { swiper: thumbSwiper },
    on: {
      slideChange: function () {
        var idx = this.activeIndex;
        $('.mobile-thumb-strip__item').removeClass('is-active');
        $('.mobile-thumb-slide[data-slide-index="' + idx + '"] .mobile-thumb-strip__item').addClass('is-active');
      }
    }
  });

  $(document).on('click', '.mobile-thumb-slide', function () {
    var idx = parseInt($(this).attr('data-slide-index'), 10);
    mySwiper.slideTo(idx);
    $('.mobile-thumb-strip__item').removeClass('is-active');
    $(this).find('.mobile-thumb-strip__item').addClass('is-active');
  });

  $(document).on("click", ".product__info-wrapper .product-form__input--pill input[type=radio]+label", function () {
    setTimeout(function () {
      $(".swiper-pagination .swiper-pagination-bullet:first-child").trigger("click");
    }, 600);
  });

  $(document).on("click", ".variant_bg_prd_page", function (event) {
    $("#firstPrdImgMainChange").hide();
  });

  setTimeout(function () {
    $(".gallery_video_box_thumb").each(function () {
      var videosrc = $(this).attr("video_src");
      $(this).next().attr("src", videosrc);
      $(this).hide();
    });
  }, 2000);
});
//# sourceMappingURL=/s/files/1/0071/9755/6794/t/179/assets/fancy_slider.js.map?v=1759971060
